import ScrollListener from '../../utils/ScrollListener';

import Header from '../header/Header.react';
import MobileNav from '../header/MobileNav.react';
import Hero from '../hero/Hero.react';
import Portfolio from '../portfolio/Portfolio.react';
import Services from '../services/Services.react';
import About from '../about/About.react';
import Team from '../team/Team.react';
import Testimonials from '../testimonials/Testimonials.react';
import Contact from '../contact/Contact.react';
import Footer from '../footer/Footer.react';

import Config from '../../utils/Config';

class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            boot    : false,
            content : false,
        };

        this.loadContent = this.loadContent.bind(this);
    }

    componentDidMount() {
        this.loadContent();

        ScrollListener.start();
    }

    loadContent() {
        var self = this;

        var hero_content = false;

        $.ajax({
            url: "./content/GeneralData.txt",
            async: false,
            success:(data) => {

                self.setState({
                    boot    : true,
                    content : JSON.parse(data)
                }, () => {
                    setTimeout(() => {
                        $('#pre-loader').animate({ opacity : 0 }, 1000);

                        setTimeout(() => {
                            $('#pre-loader').css({ display : 'none' });
                        });

                        // console.log('DATA', JSON.parse(data));

                        var projects = JSON.parse(data).portfolio.details;
                        console.log('PROJECTS', projects)
                        var match = false;
                        for (var i=0; i<projects.length; i++) {
                            if (projects[i].id === location.hash.replace('#', ''))
                                match = i;
                        }

                        if (match)
                            self.refs.Portfolio.openProject(match);
                        // for (var i=0; i<projects.length; i++) {
                        //     self.cacheImage(projects[i].id);
                        // }

                    }, 500);
                });
            }
        });
    }

    cacheImage(id) {
        var img = new window.Image();

        img.onload = function() { console.log('img cahced'); };

        img.src = Config.imgUrl()+'/public/codi-studios/projects/'+id+'/header.jpg';
    }

    render() {
        if (!this.state.boot)
            return null;

        var content = this.state.content;

        return (
            <div
                id='app'>

                <Header />
                <MobileNav />

                <Hero
                    content={content.hero} />

                <Portfolio
                    content={content.portfolio}
                    ref='Portfolio' />

                <Services
                    content={content.services} />

                <About
                    content={content.about} />

                <Team
                    content={content.team} />

                <Testimonials
                    content={content.testimonials} />

                <Contact
                    content={content.contact} />

                <Footer
                    content={content.footer} />

                <div id='pre-loader'>
                    <div id='pre-loader__icon'></div>
                </div>

            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./ui_src/app/components/app/App.react.jsx